import * as React from 'react';
import { useSelector } from 'react-redux';
import calendarEventStatus from '../../utils/calendarEventStatus';
import './CalendarStatus.scss';

export const CalendarStatus = () => {
  const eventStatus = useSelector((state) => state.calendar.eventStatus);
  const attendeeChange = useSelector((state) => state.calendar.attendeeChange);
  const isCalendarEventSaved = useSelector((state) => state.calendar.isCalendarEventSaved);
  let statusText;

  if (((isCalendarEventSaved && attendeeChange))) {
    statusText = <span>Calendar changes <strong>not saved</strong>.</span>;
  } else {
    switch (eventStatus) {
      case calendarEventStatus.preSaved:
        statusText = <span>Calendar event is <strong>pre-saved</strong>.<br></br>Send the Outlook event to save to Litify.</span>;
        break;
      case calendarEventStatus.saving:
        statusText = <span>Calendar event is <strong>saving</strong>.</span>;
        break;
      case calendarEventStatus.saved:
        statusText = <span>Calendar event is <strong>saved</strong>.</span>;
        break;
      case calendarEventStatus.deleting:
        statusText = <span><strong>Removing</strong> calendar event from Litify...</span>;
        break;
      default:
        statusText = <span>Calendar event <strong>not saved</strong>.</span>;
        break;
    }
  }

  return (
    <span className='calendar-status'>
      <div id='calendar-status'>
        { statusText }
      </div>
    </span>
  );
};
